<template>
  <content-panel>
    <template v-slot:search>
      <search-box class="search-box">
        <el-form :inline="true" size="mini" label-width="60px" :model="searchForm" :rules="rules" ref="searchForm" @change="onSearch">
          <el-form-item label="月份" prop="monthCode">
            <el-date-picker v-model="searchForm.monthCode" type="month" value-format="yyyyMM" placeholder="选择月"> </el-date-picker>
          </el-form-item>
          <el-form-item label="工号" prop="workNo">
            <el-input v-model.trim="searchForm.workNo" @keyup.enter.native="onSearch" />
          </el-form-item>
          <el-form-item label="姓名" prop="userName">
            <el-input v-model.trim="searchForm.userName" @keyup.enter.native="onSearch" />
          </el-form-item>
        </el-form>
        <template v-slot:right>
          <el-button class="green-btn" size="mini" @click="onSearch">搜索</el-button>
          <el-button class="orange-btn" size="mini" @click="reset">重置</el-button>
        </template>
      </search-box>
    </template>

    <table-panel ref="tablePanel">
      <template v-slot:header-right>
        <el-button type="primary" size="mini" @click="edit(false)">编辑</el-button>
        <el-button type="primary" size="mini" @click="exportExcel">导出</el-button>
      </template>
      <el-table
        stripe
        border
        ref="tableRef"
        :header-cell-style="{ backgroundColor: '#F4F8FB' }"
        highlight-current-row
        @selection-change="seletionChange"
        :data="tableData.list"
        :height="maxTableHeight"
        v-if="tableReload"
        v-loading="loading"
        row-key="dataId"
      >
        <el-table-column type="selection" width="40" :reserve-selection="true" fixed="left"></el-table-column>
        <el-table-column label="月份" prop="monthCode" width="110"></el-table-column>
        <el-table-column label="部门" prop="orgName" min-width="150"></el-table-column>
        <el-table-column label="工号" prop="workNo" width="120"></el-table-column>
        <el-table-column label="岗位" prop="workJobs" min-width="150"></el-table-column>
        <el-table-column label="姓名" prop="userName" width="70"></el-table-column>
        <el-table-column label="产品类型及拍摄数量" align="center">
          <el-table-column label="大片" prop="picNumBig" width="80" align="right"></el-table-column>
          <el-table-column label="小片" prop="picNumSmall" width="80" align="right"></el-table-column>
          <el-table-column label="退底" prop="picNumBottom" width="80" align="right"></el-table-column>
          <el-table-column label="特写" prop="picNumSpecial" width="80" align="right"></el-table-column>
          <el-table-column label="折算后张数" prop="conversionNum" width="110" align="right"></el-table-column>
        </el-table-column>
        <el-table-column label="类型" prop="processType" width="110"></el-table-column>
        <el-table-column label="数量提成" prop="commissionNum" width="90" align="right"></el-table-column>
        <el-table-column label="作品得分" prop="worksScore" width="90" align="right"></el-table-column>
        <el-table-column label="提成系数" prop="commissionFactor" width="90" align="right"></el-table-column>
        <el-table-column label="实发提成" prop="actualCommission" width="90" align="right"></el-table-column>
        <el-table-column label="操作" fixed="right" align="center" width="160">
          <template slot-scope="scope">
            <el-button type="text" size="mini" @click="getDetails(scope.row)">查看修片明细</el-button>
            <el-button type="text" size="mini" @click="edit(scope.row)">编辑</el-button>
          </template>
        </el-table-column>
      </el-table>
      <template v-slot:footer>
        <div style="text-align: right">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="tableData.pageNum"
            :page-sizes="[30, 60, 90]"
            :page-size="tableData.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="tableData.total"
          >
          </el-pagination>
        </div>
      </template>
    </table-panel>
    <edit-dialog :visible.sync="isShowEdit" v-if="isShowEdit" :rowData="rowData" @success="onSearch" />
  </content-panel>
</template>

<script>
import tableMixin from '@/utils/tableMixin';
import pagePathMixin from '@/utils/page-path-mixin'
import editDialog from './edit.vue';
import { downloadFile } from '@/utils';
import moment from 'moment';
export default {
  name: 'photographySalaryAccounting',
  mixins: [tableMixin, pagePathMixin],
  components: { editDialog },
  data() {
    return {
      loading: false,
      tableData: {
        list: [],
        pageNum: 1,
        pageSize: 30,
        total: 0,
      },
      tableReload: true,
      searchFormData: [],
      rules: {},
      columnData: [],
      loading: false,
      searchForm: {
        monthCode: '',
        workNo: '',
        userName: ''
      },
      isShowEdit: false,
      rowData: [],
      tableSeletion: [],
    };
  },
  computed: {},
  mounted() {
    this.onSearch();
  },
  methods: {
    onSearch() {
      this.$refs.tableRef.clearSelection();
      this.tableData.pageNum = 1;
      this.init();
    },
    async init() {
      this.loading = true;
      let data = {
        pageNum: this.tableData.pageNum,
        pageSize: this.tableData.pageSize,
        filterData: this.searchForm
      };
      this.searchFormData = data;
      this.$q.newProduct
        .photographerPayrollPage({ data: data })
        .then((res) => {
          this.tableData = res.data;
        })
        .finally((_) => {
          this.loading = false;
        });
    },

    // 分页器 pagesize
    handleSizeChange(val) {
      this.tableData.pageSize = val;
      this.tableData.pageNum = 1;
      this.init();
    },
    // 分页器 pageNum
    handleCurrentChange(val) {
      this.tableData.pageNum = val;
      this.init();
    },

    reset() {
      this.$refs.searchForm.resetFields();
      this.tableData.pageNum = 1;
      this.onSearch();
    },
    seletionChange(val) {
      this.tableSeletion = val;
    },
    getDetails(row) {
      this.openSubPage({
        path: '/newProduct/photographerFilmRepairDetails',
        query: {
          monthCode: row.monthCodeQuery,
          workNo: row.workNo,
        },
      })
    },
    edit(row) {
      if (!row && !this.tableSeletion.length) {
        this.$message.error('请选择后在进行操作！');
        return;
      }
      this.rowData = !row ? this.tableSeletion : [row];
      this.isShowEdit = true;
    },
     // 导出
    exportExcel() {
      console.log(this.searchFormData)
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      let params = {
        appCode: 'ec-pc-new',
        // paramMap: this.searchFormData.filterData,
        paramMap: {
          ...this.searchFormData.filterData
        },
        reportName: 'retouch_salary_export'
      }
      this.$q.common.exportExcel({ data: params }).then((res) => {
        if (res.success) {
          this.$message.success('提交下载任务成功，请稍后到导出列表查阅！')
          loading.close()
        } else {
          this.$message.error(res.message)
        }
      })
    },
  },
  filters: {
    cellValFormat(val) {
      if (val) {
        return val;
      } else {
        if (isNaN(val) || val == 0) {
          return val;
        } else {
          return '--';
        }
      }
    },
  },
};
</script>

<style lang="stylus" scoped></style>
